/* @sravni/react-design-system version 0.2.55 */
var css = "._5j6gdo {\n  width: 100%;\n}\n";
var modules_ff399ec7 = {"container":"_5j6gdo"};
import "../../../assets/components/ControlGroup/styles/ControlGroup.module.less-54b259fe.css";

export default modules_ff399ec7;
export { css };
